import React from 'react'
import useAuthenticationStore, { AuthenticationViews } from './Store';
import IdentifierCheck from './IdentifierCheck';

const IdentifierCheckContainer: React.FC = () => {
  const { state, dispatch, validateIdentifier } = useAuthenticationStore()
  const { identifier, serverError, isLoading } = state

  const onSetIdentifier = (newIdentifier: string) => {
    dispatch({ type: 'SET_IDENTIFIER', payload: newIdentifier })
  }

  const onValidateIdentifier = (newIdentifier: string) => {
    validateIdentifier(newIdentifier, state.redirectUrl)
  }

  return (
    <IdentifierCheck
      identifier={identifier}
      serverError={serverError}
      isLoading={isLoading}
      validateIdentifier={onValidateIdentifier}
      onSetIdentifier={onSetIdentifier}
      subActionLink={"../" + AuthenticationViews.login}
    />
  )
}

export default IdentifierCheckContainer;